import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Secure Anonymous TempMail </title>
        <meta name="description" content="The page you are looking for could not be found." />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-green-50 px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <h1 className="text-9xl font-bold text-primary-dark mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-dark hover:bg-primary-dark/90 transition-colors duration-200"
          >
            Back to Home
          </Link>

          {/* 添加装饰性元素 */}
          <div className="mt-12 flex justify-center space-x-2">
            <div className="w-2 h-2 rounded-full bg-primary-light animate-pulse"></div>
            <div className="w-2 h-2 rounded-full bg-primary animate-pulse delay-100"></div>
            <div className="w-2 h-2 rounded-full bg-primary-dark animate-pulse delay-200"></div>
          </div>
        </motion.div>
      </div>
    </>
  );
}; 